import VantPhoneImage from "../../../assets/webp/business/Phone Image vant system_converted.webp";
import VantSystemProcess from "../../../assets/icons/business/vantpaymentsystem.svg"


export const VantPaymentSystem = () => {
  return (
    <section className="w-full bg-white px-4 py-[6rem] md:px-10 lg:px-10 xl:px-32 ">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2">
        {/* Left: Phone Image */}
        <div className="">
          <img
            src={VantPhoneImage}
            alt="Payment QR on phone"
            className="object-cover"
          />
        </div>
        {/* Right: Content */}
        <div className="flex flex-col justify-center h-full px-0 md:px-8 lg:px-16">
          
                   <div className="flex text-[#32AE4C] font-[Urbanist] items-center border-[#32AE4C] border w-[60%] md:w-[50%] m-4 md:mb-[2rem] rounded-[2rem] p-[1rem]">
            <span className="h-2 w-2 bg-green-400 rounded-full mr-2"></span>
            QR Code Generator
          </div>
                  
          <h2 className="text-[#232323] text-[1.5rem] md:text-[1.7rem] lg:text-[2rem] font-[600] mb-6 leading-tight">Our payment system is easy to start using.</h2>
          <p className="text-[#232323] text-[0.9rem] mb-6 max-w-xl">
            With our platform, you can create a custom payment link for your products or services in just a few clicks. But we take it a step further — every payment link you generate can also be instantly converted into a QR code.
          </p>
          <p className="italic text-[#232323] text-[0.9rem] mb-2">Perfect for:</p>
          <ul className="mb-10 space-y-2">
            <li className="text-[#232323] text-[1rem] font-semibold flex items-center">
              <span className="h-2 w-2 bg-[#232323] rounded-full mr-3"></span>In-store payments
            </li>
            <li className="text-[#232323] text-[1rem] font-semibold flex items-center">
              <span className="h-2 w-2 bg-[#232323] rounded-full mr-3"></span>Event sales
            </li>
            <li className="text-[#232323] text-[1rem] font-semibold flex items-center" >
              <span className="h-2 w-2 bg-[#232323] rounded-full mr-3"></span>Market stalls
            </li>
            <li className="text-[#232323] text-[1rem] font-semibold flex items-center" >
              <span className="h-2 w-2 bg-[#232323] rounded-full mr-3"></span>Service-based businesses
            </li>
          </ul>
          {/* Process Flow */}
          <img src={VantSystemProcess} alt="" />
         
        </div>
      </div>
    </section>
  );
}